var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquarePencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.85 1.35) scale(0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8633 3.62469L12.389 1.13735C12.2068 0.954216 11.9116 0.954216 11.7292 1.13735L6.32636 6.56856C6.25077 6.64458 6.20329 6.74446 6.19191 6.85169L5.903 9.62928C5.88853 9.76997 5.93763 9.90962 6.03745 10.0095C6.12538 10.0979 6.24426 10.147 6.36733 10.147C6.38332 10.147 6.39969 10.146 6.41606 10.1442L9.17926 9.85374C9.28596 9.84276 9.38521 9.79504 9.46095 9.71905L14.8633 4.28787C14.9509 4.19998 15 4.08084 15 3.95624C15 3.83169 14.9509 3.71259 14.8633 3.62469ZM8.96564 8.89003L7.15106 7.0656L12.0591 2.13233L13.8736 3.9563L8.96564 8.89003Z",
    fill: "#C691FB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 2.5H6C5.44772 2.5 5 2.94772 5 3.5V16.5C5 17.0523 5.44772 17.5 6 17.5H15C15.5523 17.5 16 17.0523 16 16.5V9.6",
    stroke: "#C691FB",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarePencil);
export default __webpack_public_path__ + "static/media/square-pencil.c7087fbf824b02fef54846cba402f0ea.svg";
export { ForwardRef as ReactComponent };